import { Group, Stack, TextInput } from '@mantine/core'
import Search from '../../components/common/search/Search.jsx'
import HeaderActionsV2 from '../../components/common/common-header-v2/HeaderActionsV2.jsx'
import AppIcon from '../common/AppIcon'
import { useIntl } from 'react-intl'
import AppLegacyButton from '../common/AppLegacyButton.tsx'
import { useNavigate } from 'react-router-dom'
import { themeCfg } from '../../theme/theme.ts'
import { useDebouncedCallback } from '@mantine/hooks'
import { useState } from 'react'

// @Deprecated
interface CustomProps {
  title?: string
  dataFacade?: any
  handlerHeaderActions?: any
  toolbar?: string | React.ReactNode
}

const AppHeaderView = ({
  title,
  dataFacade,
  handlerHeaderActions,
  toolbar,
}: CustomProps) => {
  const { formatMessage: msg } = useIntl()
  const navigate = useNavigate()
  const height = 50

  const Title = () => {
    return (
      <Group
        justify="flex-start"
        wrap="nowrap"
        fw="bold"
        mih={height}
        c="primary"
      >
        {typeof title === 'string' ? (
          <span
            style={{
              fontSize: '110%',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {title}
          </span>
        ) : (
          title
        )}
      </Group>
    )
  }

  const Search = () => {
    const [localValue, setLocalValue] = useState(
      dataFacade?.searchOptions?.filter,
    )

    const debouncedOnChange = useDebouncedCallback(
      (e: any) => {
        dataFacade?.searchOptions?.updateFilter(e)
      },
      300, // milisegundos de debounce
    )

    if (dataFacade)
      return (
        <Group
          justify="flex-end"
          wrap="nowrap"
          fw="bold"
          mih={height}
          c="primary"
        >
          <TextInput
            autoFocus
            rightSection={<AppIcon icon="search" />}
            placeholder={
              (dataFacade?.searchOptions?.placeholder &&
                msg({ id: `${dataFacade?.searchOptions?.placeholder}` })) ||
              msg({ id: 'search' })
            }
            icon={<AppIcon icon="search" />}
            value={localValue}
            onChange={(e) => {
              setLocalValue(e.target.value)
              debouncedOnChange(e)
            }}
            {...dataFacade?.searchOptions} // Spread the searchOptions props here
          />
        </Group>
      )
    return null
  }

  const Toolbar = () => (
    <Group gap="xs" justify="flex-end" wrap="nowrap">
      {handlerHeaderActions?.showBackButton && (
        <AppLegacyButton
          icon="back"
          iconPosition="left"
          label={msg({ id: 'button.back' })}
          onClick={() => {
            if (handlerHeaderActions?.backButton) {
              handlerHeaderActions?.backButton()
            } else {
              navigate(-1)
            }
          }}
          color="primary"
          variant="outline"
        />
      )}

      {handlerHeaderActions?.primaryButton && (
        <AppLegacyButton
          icon={handlerHeaderActions?.primaryButtonIcon}
          iconPosition="right"
          label={
            handlerHeaderActions?.primaryButtonText
              ? msg({ id: handlerHeaderActions?.primaryButtonText })
              : ''
          }
          disabled={handlerHeaderActions?.isDisabledPrimaryButton || false}
          onClick={() => handlerHeaderActions?.primaryButton()}
          color="white"
          bg="moure-blue"
        />
      )}

      {handlerHeaderActions?.secondaryButton && (
        <AppLegacyButton
          icon={handlerHeaderActions?.secondaryButtonIcon}
          iconPosition="right"
          label={
            handlerHeaderActions?.secondaryButtonText
              ? msg({ id: handlerHeaderActions?.secondaryButtonText })
              : ''
          }
          disabled={handlerHeaderActions?.isDisabledSecondaryButton || false}
          onClick={() => handlerHeaderActions?.secondaryButton()}
          color="white"
          bg="moure-orange"
        />
      )}

      {toolbar && toolbar}
    </Group>
  )

  return (
    <Group w="100%" wrap="nowrap" justify="space-between" h={50}>
      <Title />
      <Group justify="flex-end">
        <Search />
        <Toolbar />
      </Group>
    </Group>
  )
}

export default AppHeaderView
